<agr-form-dialog [formGroup]="formGroup" [data]="data" (confirm)="confirm()" (cancel)="cancel()" class="flex--gutter-container">
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'year' | translate }}</mat-label>
      <input type="number" matInput placeholder="{{ 'year' | translate }}" formControlName="calendarYear" data-test="edit-year-name" />
    </mat-form-field>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'crop' | translate }} </mat-label>
      <input
        type="text"
        [placeholder]="'crop' | translate"
        matInput
        formControlName="cropId"
        [matAutocomplete]="cropAutocomplete"
        data-test="edit-cropfield-crop"
      />
      <mat-autocomplete #cropAutocomplete="matAutocomplete" [displayWith]="displayCrop()">
        @for (option of filteredCrops$ | async; track option) {
          <mat-option [value]="option.id" data-test="edit-cropfield-crop-option">
            {{ option.name }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'pCaClFromAndIncluding' | translate }}</mat-label>
      <input
        type="number"
        matInput
        step="0.01"
        placeholder="{{ 'pCaClFromAndIncluding' | translate }}"
        formControlName="pCaClFromAndIncluding"
        data-test="edit-pCaClFromAndIncluding-name"
      />
    </mat-form-field>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'pCaClToAndIncluding' | translate }}</mat-label>
      <input
        type="number"
        step="0.01"
        matInput
        placeholder="{{ 'pCaClToAndIncluding' | translate }}"
        formControlName="pCaClToAndIncluding"
        data-test="edit-pCaClToAndIncluding-name"
      />
    </mat-form-field>
  </div>
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'pAlFromAndIncluding' | translate }}</mat-label>
      <input
        type="number"
        matInput
        step="0.01"
        placeholder="{{ 'pAlFromAndIncluding' | translate }}"
        formControlName="pAlFromAndIncluding"
        data-test="edit-pAlFromAndIncluding-name"
      />
    </mat-form-field>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'pAlToAndIncluding' | translate }}</mat-label>
      <input
        type="number"
        step="0.01"
        matInput
        placeholder="{{ 'pAlToAndIncluding' | translate }}"
        formControlName="pAlToAndIncluding"
        data-test="edit-pAlToAndIncluding-name"
      />
    </mat-form-field>
  </div>
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'pwFromAndIncluding' | translate }}</mat-label>
      <input
        type="number"
        matInput
        step="0.01"
        placeholder="{{ 'pwFromAndIncluding' | translate }}"
        formControlName="pwFromAndIncluding"
        data-test="edit-pwFromAndIncluding-name"
      />
    </mat-form-field>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'pwToAndIncluding' | translate }}</mat-label>
      <input
        type="number"
        step="0.01"
        matInput
        placeholder="{{ 'pwToAndIncluding' | translate }}"
        formControlName="pwToAndIncluding"
        data-test="edit-pwToAndIncluding-name"
      />
    </mat-form-field>
  </div>
  <div class="flex--row flex--gutter">
    <mat-form-field>
      <mat-label>{{ 'condition' | translate }}</mat-label>
      <mat-select formControlName="condition" placeholder="{{ 'condition' | translate }}" data-test="edit-condition-name">
        @for (condition of conditions | keyvalue; track condition) {
          <mat-option [value]="condition.key">{{ getConditionString(condition.key) }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'phosphateNorm' | translate }}</mat-label>
      <input
        type="number"
        matInput
        step="1"
        placeholder="{{ 'phosphateNorm' | translate }}"
        formControlName="phosphateNorm"
        data-test="edit-phosphateNorm-name"
      />
    </mat-form-field>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'poorInPhosphateNorm' | translate }}</mat-label>
      <input
        type="number"
        step="1"
        matInput
        placeholder="{{ 'poorInPhosphateNorm' | translate }}"
        formControlName="poorInPhosphateNorm"
        data-test="edit-poorInPhosphateNorm-name"
      />
    </mat-form-field>
  </div>
  <div class="flex--row flex--gutter">
    <div class="mat-slide-group">
      <mat-slide-toggle color="primary" formControlName="isTransitionVariant" data-test="edit-isTransitionVariant-name">{{
        'isTransitionVariant' | translate
      }}</mat-slide-toggle>
    </div>
  </div>
</agr-form-dialog>
